<template>
    <DetailComponent
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :parent_id="parent_id"
        :rest_api_note="rest_api_note"
        :title_page="title_page"
        :single_object="single_object"
        :array_options="array_options"
        :form_format="form_format"
        :notes="single_object.notes_entities"
        :back_href="'/building-cost-center'"
    />    
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import DetailComponent  from    '@/components/DetailComponent/DetailComponent'
import { Notyf }        from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'CostCenterDetail',
    components: {
        DetailComponent
    },
    
    data(){
        return{
            notyf,
            parent_id:          this.$route.params.id,
            rest_api:           `cost_center/${this.$route.params.id}`,
            rest_api_note:      `cost_center_notes`,
            form_format:        FormResources.form_format,
            breadcrumb:         Resources.breadcrumb,
            title_page:         '',
            content_header:     this.$store.state.headers,
            single_object:      {},
            array_options:      {},
        }
    },

    methods:{

        fill_data(data) {
            this.single_object  = data.cost_center;
            this.title_page     = this.single_object.name;
            this.breadcrumb[1].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.name,
                href:   '#',
                arrow:  " ",
            });
        },

    },

    async mounted(){
        if(this.hasPermissions(['Building-Cost-Center Read']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    }
}
</script>